import * as React from "react";
import {useClearCache} from "react-clear-cache";

const ClearCache = () => {
    const {emptyCacheStorage} = useClearCache();
    return (
        <div>
            <h3 style={{textAlign: "center"}}>
                <a href="#"
                    onClick={e => {
                        e.preventDefault();
                        emptyCacheStorage();
                        alert("Clear Cache Successful")
                    }}
                >
                    Update version
                </a>
            </h3>
        </div>
    );
};

export default ClearCache;